import { ChangeEvent } from 'react'
import { FormField } from '../../../../Components'
import TextArea from 'react-textarea-autosize'
import { defineMessages, useIntl } from 'react-intl'

import styles from './BombBombSendFormBody.module.scss'

export const MSG = defineMessages({
  label: {
    id: 'BombBomb.form.body.label',
    defaultMessage: 'Body'
  },
  placeholder: {
    id: 'BombBomb.form.body.placeholder',
    defaultMessage: 'Message content…'
  }
})

export interface BombBombSendFormBodyProps {
  body: string
  setBody(body: string): void
}

const BodyTextArea = props => <TextArea maxRows={15} minRows={5} {...props} />

export const BombBombSendFormBody = ({ body, setBody }: BombBombSendFormBodyProps) => {
  const intl = useIntl()

  return (
    // @ts-ignore
    <FormField
      value={body}
      input={BodyTextArea}
      inputClassName={styles.txt}
      name='recorder-email-body-content'
      placeholder={intl.formatMessage(MSG.placeholder)}
      onChange={(e: ChangeEvent<HTMLInputElement>) => setBody(e.target.value)}
    >
      {intl.formatMessage(MSG.label)}
    </FormField>
  )
}
